import { IdentifierDTO } from '@zazume/zzm-base';

import {
  MarketInsightsPortfolioParams,
  PublicationMarketInsightDetail,
  PublicationMarketInsightRow
} from '#/models/marketInsights/MarketInsights';

import { doGet } from '../../helpers';

const toQueryString = (params: MarketInsightsPortfolioParams): string => {
  const entries = Object.entries(params).filter(([, value]) => Boolean(value)) as [string, string][];
  if (entries.length === 0) {
    return '';
  }
  return `?${new URLSearchParams(entries).toString()}`;
};

export const marketInsights = {
  getPortfolio:
    (params: MarketInsightsPortfolioParams = {}) =>
    () =>
      doGet<PublicationMarketInsightRow[]>(`/dashboard/market-insights/publications${toQueryString(params)}`),
  getByPublication: (publicationWindowId: IdentifierDTO) => () =>
    doGet<PublicationMarketInsightDetail>(`/dashboard/market-insights/publication/${publicationWindowId}`)
};
